import React from "react";
import { useNavigate } from "react-router-dom";

const Start = () => {
    const navigate = useNavigate();
    const handleMyname =() => {
      navigate('/flamesgame')
    }
  return (
    <div>
      <button className= "button" onClick={handleMyname}>Lets goooo</button>
    </div>
  );
};

export default Start;
